export const LOCALES = ["ru", "en", "tg"] as const;
export type AppLocale = (typeof LOCALES)[number];

/** Emoji flags for the locale switcher. */
export const LOCALE_FLAG_EMOJI: Record<AppLocale, string> = {
  ru: "🇷🇺",
  en: "🇬🇧",
  tg: "🇹🇯",
};

export const defaultLocale: AppLocale = "ru";
export const LOCALE_COOKIE = "NEXT_LOCALE";

export function isAppLocale(v: string | undefined): v is AppLocale {
  return v === "ru" || v === "en" || v === "tg";
}

/** Для словарей с ru/en: тоҷикӣ пока использует русские строки. */
export function contentLocale(locale: AppLocale): "ru" | "en" {
  return locale === "en" ? "en" : "ru";
}
